<template>
  <section ref="section" class="fluent-free-time-mobile">
    <div class="free-time-background-mobile"></div>
    <div ref="sticky" class="fluent-free-time-mobile-sticky">
      <div ref="text" v-textMotion class="text-intro free-time-mobile-text-intro">
        <div class="sub-title">
          <p v-if="lang !== 'zh'">{{ $t('free-time-title') }}</p>
          <p v-if="lang === 'zh'">{{ $t('free-time-title-1') }}</p>
          <p v-if="lang === 'zh'">{{ $t('free-time-title-2') }}</p>
        </div>
        <p class="description">{{ $t('free-time-description') }}</p>
      </div>
      <div
        class="free-time-mobile-phone-container"
        :class="showPhoneContainer ? 'keyVisionMotion' : 'visibility-hidden'"
      >
        <img
          ref="phone"
          v-lazy="require(`../../assets/${lang === 'zh' ? 'zh/' : ''}fluent/power-phone-mobile-0.png`)"
          alt="ColorOS 11"
          class="free-time-mobile-phone-img"
        />
        <img
          v-lazy="require(`../../assets/${lang === 'zh' ? 'zh/' : ''}fluent/power-phone-mobile-1.png`)"
          alt="ColorOS 11"
          class="free-time-mobile-phone-img free-time-mobile-phone-swipe"
          :class="phoneSwipeIndex > 0 ? 'free-time-mobile-phone-show' : ''"
        />
        <!-- <img
          v-lazy="require('../../assets/fluent/power-phone-mobile-2.png')"
          alt="ColorOS 11"
          class="free-time-mobile-phone-img free-time-mobile-phone-swipe"
          :class="phoneSwipeIndex > 1 ? 'free-time-mobile-phone-show' : ''"
        /> -->
        <ul class="free-time-garbage-list" :class="phoneSwipeIndex > 1 ? '' : 'free-time__hide'">
          <li
            v-for="(garbage, index) in garbageList"
            :key="index"
            class="free-time-garbage"
            :class="{ keyVisionMotionGarbage: phoneSwipeIndex > 1 }"
            :style="{
              opacity: garbage.progress >= 0.99 ? garbage.opacity : undefined,
              transform: garbage.progress >= 0.99 ? garbage.translate3d : undefined,
              animationDuration: progress >= 0.3 ? '0s' : undefined,
              animationDelay: progress >= 0.3 ? '0s' : undefined
            }"
          >
            <div
              class="free-time-garbage-mask"
              :style="`transform: translate3d(${-100 + 100 * Math.min(0.99, garbage.progress)}%, 0px, 0px);`"
            ></div>
            <img src="../../assets/fluent/free-time-garbage-icon.png" alt="ColorOS 11" class="garbage-left-icon" />
            <div class="garbage-middle-text">
              <div class="garbage-middle-text-title">{{ $t(`free-time-garbage-title-${index}`) }}</div>
              <div class="garbage-middle-text-sub-title">{{ $t(`free-time-garbage-size-${index}`) }}</div>
            </div>
            <img
              v-if="garbage.progress > 0 && garbage.progress <= 0.99"
              src="../../assets/fluent/free-time-garbage-loading.png"
              alt="ColorOS 11"
              class="garbage-right-icon"
            />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';

const SUM_PROGRESS = 2.5;
const GARBAGE_START_PROGRESS = 0.25 / SUM_PROGRESS;
const GARBAGE_START_TRANS = 1.25 / SUM_PROGRESS;

export default {
  inject: ['lang'],
  data() {
    return {
      phoneSwipeIndex: 0,
      progress: 0,
      showPhoneContainer: false,
      garbageList: [
        {
          progress: 0,
          translate3d: 'translate3d(0, 0, 0)',
          opacity: 1
        },
        {
          progress: 0,
          translate3d: 'translate3d(0, 0, 0)',
          opacity: 1
        },
        {
          progress: 0,
          translate3d: 'translate3d(0, 0, 0)',
          opacity: 1
        },
        {
          progress: 0,
          translate3d: 'translate3d(0, 0, 0)',
          opacity: 1
        }
      ]
    };
  },
  mounted() {
    const clientHeight = window.innerHeight;
    if (this.$refs.phone) {
      // this.$refs.sticky.style.height = clientHeight + 'px';
      // this.$refs.phone.style.height = clientHeight - this.$refs.text.clientHeight + 'px';
    }
    const offset = window.innerHeight - this.$refs.sticky.clientHeight - (this.lang === 'zh' ? 42 : 92);

    this.scene = new ScrollMagic.Scene({
      duration: SUM_PROGRESS * clientHeight,
      triggerElement: '.fluent-free-time-mobile',
      triggerHook: 0,
      offset: -offset
    })
      .setPin('.fluent-free-time-mobile-sticky')
      .addTo(Controller)
      .on('progress', e => {
        this.handleProgress(e.progress);
      });
    const sceneInto = new ScrollMagic.Scene({
      triggerElement: '.free-time-mobile-phone-container',
      triggerHook: 1,
      offset: 100,
      duration: SUM_PROGRESS * clientHeight - 500
    })
      .addTo(Controller)
      .on('progress', e => {
        if (e.progress !== 0 && e.progress !== 1) {
          this.showPhoneContainer = true;
          sceneInto.destroy(true);
        }
      });
    setTimeout(() => {
      this.resizeHandler();
    }, 100);
    window.addEventListener('resize', this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    resizeHandler() {
      if (this.scene) {
        const delta = this.$refs.text.clientHeight < 200 ? (this.lang === 'zh' ? 46 : 92) : 0;
        this.scene.offset(-(window.innerHeight - this.$refs.sticky.clientHeight - delta));
      }
    },
    handleProgress(progress) {
      this.progress = progress;
      if (progress < 0.25 / SUM_PROGRESS) {
        this.phoneSwipeIndex = 0;
      } else if (progress < 2.25 / SUM_PROGRESS) {
        this.phoneSwipeIndex = 2;
      } else {
        this.phoneSwipeIndex = 0;
      }
      this.garbageList.forEach((item, index) => {
        item.progress = Math.min(1, Math.max(0, (progress - GARBAGE_START_PROGRESS) / (0.25 / SUM_PROGRESS) - index));
        const transRate = Math.min(1, Math.max(0, (progress - GARBAGE_START_TRANS) / (0.25 / SUM_PROGRESS) - index));
        item.opacity = progress <= GARBAGE_START_TRANS ? 1 : 1 - transRate;
        item.translate3d =
          progress <= GARBAGE_START_TRANS ? 'translate3d(0, 0, 0)' : `translate3d(${-230 * transRate}px, 0, 0)`;
      });
    }
  }
};
</script>
<style lang="scss">
.fluent-free-time-mobile {
  min-height: 220vh;
  position: relative;
}
.fluent-free-time-mobile-sticky {
  position: relative;
  /* height: 100vh; */
  text-align: center;
  font-size: 0;
  overflow: hidden;
  z-index: 1;
}
.free-time-background-mobile {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f6f6f7;
}
.fluent-free-time-mobile .free-time-mobile-text-intro .sub-title {
  color: #000;
}

html:not([lang|='zh-CN']) {
  .fluent-free-time-mobile .free-time-mobile-text-intro .sub-title {
    max-width: 90%;
  }
}
.free-time-mobile-text-intro,
.free-time-mobile-phone-container {
  position: relative;
  z-index: 1;
}
.free-time-mobile-phone-container {
  animation-delay: 0.3s;
  animation-duration: 1s;
  animation-fill-mode: backwards;
  display: inline-block;
  height: 111.9vw;
}
@media screen and (min-height: 750px) and (min-width: 734px) {
  .free-time-mobile-text-intro.text-intro {
    padding-bottom: 100px;
  }
}
.free-time-mobile-phone-img {
  /* width: 243px; */
  /* height: calc(100vh - 272px); */
  width: 64.8vw;
  height: 111.9vw;
}
.free-time-mobile-phone-swipe {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  opacity: 0;
  height: 100%;
}
.free-time-mobile-phone-show {
  opacity: 1;
  transition: 1s ease;
}
</style>
